import { render, staticRenderFns } from "./TopHeader.vue?vue&type=template&id=ba4566a2&scoped=true&"
import script from "./TopHeader.vue?vue&type=script&lang=js&"
export * from "./TopHeader.vue?vue&type=script&lang=js&"
import style0 from "./TopHeader.vue?vue&type=style&index=0&id=ba4566a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4566a2",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/TopHeader.vue
// module id = null
// module chunks = 